import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SESSION_EXPIRED_MESSAGE } from "constants/apiErrorMessages";
import routes from "constants/routes";
import {
  buildRedirectTarget,
  getLoginPathWithRedirect,
  isLoginPath,
  logout,
} from "helpers/authSession";
import { subscribeSessionAuthError } from "helpers/sessionExpiredNotifier";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

const useUnauthorizedSessionHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openSnackbar } = useSnackbarContext();
  const isHandlingRef = useRef(false);

  useEffect(() => {
    return subscribeSessionAuthError((message) => {
      if (!message) {
        isHandlingRef.current = false;
        return;
      }

      if (isHandlingRef.current) {
        return;
      }

      isHandlingRef.current = true;

      const snackbarMessage = message || SESSION_EXPIRED_MESSAGE;
      openSnackbar(snackbarMessage, "error");

      if (isLoginPath(location.pathname)) {
        logout();
        return;
      }

      const redirectTarget = buildRedirectTarget(
        location.pathname,
        location.search
      );

      logout();
      navigate(getLoginPathWithRedirect(redirectTarget), { replace: true });
    });
  }, [location.pathname, location.search, navigate, openSnackbar]);
};

export default useUnauthorizedSessionHandler;
